import React from "react";
import OrderSection from "pageComponents/ordersAndLeads/orders/OrderSection";

export default function OrderPage(){
    return(
        <div className="mt-[10vh]">
        <OrderSection/>
        </div>
    );
}